document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-hockey-product]');
  if (!root) return;

  const unitPrice = parseFloat(root.dataset.unitPrice) || 0;
  const names = (root.dataset.designNames || '').split('|').filter(Boolean);
  const thumbs = (root.querySelector('[data-thumb-list]') || { textContent: '' }).textContent.split('|');
  const variantId = root.dataset.variantId || null;
  const tiers = JSON.parse(root.querySelector('[data-tiers-json]').textContent);
  const perItemTitle = (root.querySelector('[data-per-item-title]') || { textContent: 'design and size' }).textContent;
  const qtyTitle = (root.querySelector('[data-qty-title]') || { textContent: 'EXACT QUANTITY' }).textContent;
  const qtySub = (root.querySelector('[data-qty-sub]') || { textContent: '' }).textContent;
  const savingsLabel = (root.querySelector('[data-savings-label]') || { textContent: 'Bundle savings' }).textContent;
  const sizes = (() => {
    const el = root.querySelector('[data-sizes-list]');
    const list = (el ? el.textContent : 'S,M,L,XL').split(',').map(s => s.trim()).filter(Boolean);
    return list.length ? list : ['S','M','L','XL'];
  })();

  const mainImg = root.querySelector('[data-main-image]');
  const styleLabel = root.querySelector('[data-style-label]');
  const designLabel = (root.querySelector('[data-design-label]') || {}).dataset?.designLabel || 'Style';
  const thumbsBox = root.querySelector('[data-thumbs]');
  const bundlesEl = root.querySelector('[data-bundles]');
  const summaryEl = root.querySelector('[data-summary]');
  const totalEl = root.querySelector('[data-total]');
  const msgEl = root.querySelector('[data-message]');
  const submitBtn = root.querySelector('[data-submit]');
  const submitLabel = root.querySelector('[data-submit-label]');
  const btnBase = submitLabel ? submitLabel.textContent : 'CHECKOUT';

  let items = [{ design: names[0] || '', size: sizes[0] || 'S' }];
  let qty = 1;
  let activeTier = 0;

  const money = n => '$' + n.toFixed(2);
  const discountFor = q => { let b = 0; tiers.forEach(t => { if (q >= t.qty && t.off > b) b = t.off; }); return b; };
  const thumbFor = d => thumbs[names.indexOf(d)] || thumbs[0] || '';

  function setMainImage(url, name) {
    if (mainImg && url) { mainImg.src = url; if (name) mainImg.alt = name; }
  }
  function syncStyleLabel() {
    if (styleLabel) styleLabel.innerHTML = `${designLabel}: <strong>${items[0].design} · ${items[0].size}</strong>`;
  }

  function renderBundles() {
    bundlesEl.innerHTML = '';
    tiers.forEach((t, ti) => {
      const total = unitPrice * t.qty * (1 - t.off / 100);
      const was = unitPrice * t.qty;
      const active = ti === activeTier;
      const card = document.createElement('div');
      card.className = 'bundle-card' + (active ? ' is-active' : '');
      card.innerHTML =
        `<input type="radio" name="bundle" value="${t.qty}" ${active ? 'checked' : ''} aria-label="${t.label}">` +
        `<span class="bundle-radio"></span>` +
        `<span class="bundle-info">${t.badge ? `<small>${t.badge}</small>` : (t.sub ? `<small>${t.sub}</small>` : '')}<strong>${t.label}</strong>` +
        (t.note ? `<span class="gift-tag">${t.note}</span>` : '') + `</span>` +
        `<span class="bundle-price">${t.off ? `<s>${money(was)}</s>` : ''}<b>${money(total)}</b>` +
        (t.off ? `<small>${t.off}% savings</small>` : (t.sub ? `<small>${t.sub}</small>` : '')) + `</span>`;
      if (active) {
        const expand = document.createElement('div');
        expand.className = 'bundle-expand';
        expand.innerHTML = `<div data-per-items></div>
          <div class="qty-row"><div><strong>${qtyTitle}</strong><small>${qtySub}</small></div>
          <div class="stepper"><button type="button" data-minus aria-label="Decrease">−</button><output data-qty>${qty}</output><button type="button" data-plus aria-label="Increase">+</button></div></div>`;
        card.appendChild(expand);
        renderPerItems(expand.querySelector('[data-per-items]'));
        expand.querySelector('[data-minus]').addEventListener('click', e => { e.stopPropagation(); setQty(qty - 1); });
        expand.querySelector('[data-plus]').addEventListener('click', e => { e.stopPropagation(); setQty(qty + 1); });
      }
      card.querySelector('input').addEventListener('change', () => selectTier(ti));
      card.addEventListener('click', e => { if (!e.target.closest('select') && !e.target.closest('button')) selectTier(ti); });
      bundlesEl.appendChild(card);
    });
  }

  function renderPerItems(container) {
    container.innerHTML = '';
    items.forEach((it, idx) => {
      const row = document.createElement('div');
      row.className = 'per-item';
      const opts = names.map(n => {
        const o = sizes.map(s => `<option value="${n}|||${s}" ${n === it.design && s === it.size ? 'selected' : ''}>${n} · ${s}</option>`).join('');
        return o;
      }).join('');
      row.innerHTML = `<img src="${thumbFor(it.design)}" alt="" width="48" height="48">` +
        `<label>Hoodie ${idx + 1} ${perItemTitle}<select data-pi="${idx}">${opts}</select></label>`;
      container.appendChild(row);
    });
    container.querySelectorAll('[data-pi]').forEach(sel => {
      sel.addEventListener('change', e => {
        const [d, s] = e.target.value.split('|||');
        const i = +e.target.dataset.pi;
        items[i] = { design: d, size: s };
        const row = e.target.closest('.per-item');
        if (row) row.querySelector('img').src = thumbFor(d);
        syncStyleLabel();
        renderSummary();
      });
    });
  }

  function addonTotal() {
    let t = 0;
    root.querySelectorAll('[data-addons] input[data-addon-price]:checked').forEach(c => { t += parseFloat(c.dataset.addonPrice) || 0; });
    return t;
  }
  function addonLines() {
    const lines = [];
    root.querySelectorAll('[data-addons] input[data-addon-price]:checked').forEach(c => {
      lines.push({ name: c.dataset.addonName, price: parseFloat(c.dataset.addonPrice) || 0 });
    });
    return lines;
  }
  function giftIncluded() { return qty >= 3; }

  function renderSummary() {
    const off = discountFor(qty);
    const sub = unitPrice * qty;
    const discounted = sub * (1 - off / 100);
    const addons = addonTotal();
    const total = discounted + addons;
    let html = '';
    items.forEach((it, i) => {
      html += `<div class="summary-row item-row"><span>Item ${i + 1}</span><span class="r">${it.design} · ${it.size}</span></div>`;
    });
    if (giftIncluded()) html += `<div class="summary-row item-row"><span>Mystery gift</span><span class="r">Included</span></div>`;
    addonLines().forEach(a => { html += `<div class="summary-row"><span>${a.name}</span><span class="r">+${money(a.price)}</span></div>`; });
    if (off) html += `<div class="summary-row discount"><span>${savingsLabel}</span><span class="r">−${money(sub - discounted).replace('$', '$')}</span></div>`;
    summaryEl.innerHTML = html;
    totalEl.textContent = money(total);
    if (submitLabel) submitLabel.textContent = `${btnBase} · ${money(total)}`;
    // price line near title
    const priceEl = root.querySelector('[data-price]');
    if (priceEl) priceEl.textContent = money(unitPrice);
  }

  function selectTier(ti) {
    activeTier = ti;
    setQty(tiers[ti].qty, true);
  }

  function setQty(n, keepTier) {
    qty = Math.min(100, Math.max(1, n));
    while (items.length < qty) items.push({ design: items[0].design, size: items[0].size });
    items = items.slice(0, qty);
    if (!keepTier) {
      // pick the tier whose qty matches, else keep custom
      let best = 0;
      tiers.forEach((t, i) => { if (t.qty <= qty) best = i; });
      activeTier = best;
    }
    renderBundles();
    syncStyleLabel();
    renderSummary();
    syncGiftAddon();
  }

  function syncGiftAddon() {
    // Mystery gift row shows "Included" state when qty >= 3
    const giftRow = root.querySelector('[data-gift-row]');
    if (giftRow) {
      const priceEl = giftRow.querySelector('.addon-price');
      const input = giftRow.querySelector('input');
      if (giftIncluded()) {
        if (priceEl) priceEl.textContent = 'Included';
        if (input) { input.checked = true; input.disabled = true; }
      } else {
        const p = parseFloat(input.dataset.addonPrice) || 0;
        if (priceEl) priceEl.textContent = '+' + money(p);
        if (input) { input.disabled = false; }
      }
    }
  }

  // Design pills → switch image
  root.querySelectorAll('[data-designs] input[name="design"]').forEach(input => {
    input.addEventListener('change', () => {
      items.forEach(it => { it.design = input.value; });
      items[0].design = input.value;
      setMainImage(input.dataset.image, input.value);
      if (thumbsBox) thumbsBox.querySelectorAll('.thumb').forEach(b =>
        b.setAttribute('aria-pressed', b.dataset.design === input.value ? 'true' : 'false'));
      syncStyleLabel();
      renderBundles();
      renderSummary();
    });
  });

  // Thumbnails → switch image + pill
  if (thumbsBox) {
    thumbsBox.addEventListener('click', e => {
      const btn = e.target.closest('.thumb');
      if (!btn) return;
      thumbsBox.querySelectorAll('.thumb').forEach(b => b.setAttribute('aria-pressed', 'false'));
      btn.setAttribute('aria-pressed', 'true');
      setMainImage(btn.dataset.image, btn.dataset.design);
      const match = root.querySelector(`[data-designs] input[value="${CSS.escape(btn.dataset.design)}"]`);
      if (match) { match.checked = true; items.forEach(it => it.design = match.value); }
      syncStyleLabel();
      renderBundles();
      renderSummary();
    });
  }

  root.querySelectorAll('[data-addons] input[data-addon-price]').forEach(c => c.addEventListener('change', renderSummary));

  submitBtn.addEventListener('click', async () => {
    msgEl.textContent = '';
    renderSummary();
    if (variantId) {
      submitBtn.disabled = true;
      try {
        const props = {};
        items.forEach((it, i) => { props[`Hoodie ${i + 1}`] = `${it.design} · ${it.size}`; });
        if (giftIncluded()) props['Mystery gift'] = 'Included';
        addonLines().forEach(a => { props[a.name] = 'Yes'; });
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty, properties: props })
        });
        if (!res.ok) throw new Error('add failed');
        window.location.href = '/cart';
      } catch (err) {
        msgEl.textContent = 'Could not add to cart. Please try again.';
        submitBtn.disabled = false;
      }
    } else {
      msgEl.textContent = `Order ready: ${qty} hoodie${qty > 1 ? 's' : ''} — ${totalEl.textContent} (shipping included). Link a Shopify product in the theme editor to enable checkout.`;
    }
  });

  setQty(1, true);
});
